import { render, staticRenderFns } from "./EventReviewPurchaseModalButton.vue?vue&type=template&id=0602f13b&scoped=true&"
import script from "./EventReviewPurchaseModalButton.vue?vue&type=script&lang=js&"
export * from "./EventReviewPurchaseModalButton.vue?vue&type=script&lang=js&"
import style0 from "./EventReviewPurchaseModalButton.vue?vue&type=style&index=0&id=0602f13b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0602f13b",
  null
  
)

export default component.exports